import { NormalButton, IcNotFound as icNotFound } from '@/shared/ui';
import useNotFound from './useNotFound';
import './styles.scss';

/**
 * Renders the 404 screen, which doubles as the over-capacity notice for AI processing. Shows the holter processor limit message when useNotFound reports isNotEnoughHolterProcessor, otherwise the plain page-not-found text, with a button returning to the call center portal.
 *
 * @returns The rendered not-found screen.
 */
const NotFound = () => {
  const { state, onClickBack } = useNotFound();

  return (
    <div className="not-found-page">
      <div className="block-center">
        <img src={icNotFound} alt="not found" />
        {state?.isNotEnoughHolterProcessor ? (
          <>
            <div className="main-text">Sorry!</div>
            <div className="sub-text">
              The current limit for viewing and processing reports by AI has been exceeded.
            </div>
            <div className="sub-sub-text">Please try again later.</div>
          </>
        ) : (
          <>
            <div className="main-text">Page not found</div>
            <div className="sub-text">
              Sorry, the page you are looking for doesn’t exist or has been moved.
            </div>
          </>
        )}
        <NormalButton buttonName="Back to Call Center Portal" onClick={onClickBack} />
      </div>
    </div>
  );
};

export default NotFound;
